"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasmX = void 0;
const WasmQuerier_1 = require("./WasmQuerier");
const MarketAPI_1 = require("./api/MarketAPI");
const NftAPI_1 = require("./api/NftAPI");
const WasmTx_1 = require("./WasmTx");
const api_1 = require("./api");
class WasmX {
    constructor(lcd, chainId) {
        this.querier = new WasmQuerier_1.WasmQuerier(lcd, chainId);
        this.market = new MarketAPI_1.MarketAPI(lcd);
        this.nft = new NftAPI_1.NftAPI(lcd);
        this.collection = new api_1.CollectionAPI(lcd);
    }
    buildWasmTx(sender, messages, memo) {
        return __awaiter(this, void 0, void 0, function* () {
            const wasmTx = new WasmTx_1.WasmTx(this.querier, sender, messages, memo);
            yield wasmTx.init();
            return wasmTx;
        });
    }
}
exports.WasmX = WasmX;
